import { render, staticRenderFns } from "./ConfiguracaoRecomendacao.vue?vue&type=template&id=6f360c46&"
import script from "./ConfiguracaoRecomendacao.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoRecomendacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports